<template>
  <div class="download">
    <banner :img="banner" title="联系我们" />
    <div class="content">
      <div class="sub">
        <p class="title">客服服务</p>
        <div>联系电话：0756-6969121</div>
        <div>Email：service@aispatial.com</div>
      </div>
      <div class="sub">
        <p class="title">商务合作</p>
        <div>联系人：王女士</div>
        <div>Email：service@aispatial.com</div>
      </div>
      <div class="sub">
        <p class="title">公司位置</p>
        <div>珠海市横琴粤澳深度合作区十字门大道338号1栋8楼8076</div>
      </div>
      <div class="img_wraper">
        <img
          class="company-adress"
          src="../assets/img/company_adress.png"
          alt="地图"
        />
      </div>
    </div>
    <!-- <div style="text-align:center;margin-bottom:10px">公司位置</div> -->
    <!-- <div class="mapWrapper"> -->
    <!-- <img src="../assets/img/company_adress.png" alt="地图"> -->
    <!-- <div id="allmap" style="width: 700px;height: 500px;"></div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  data() {
    return {
      banner: require("../assets/img/rencai.jpg"),
    };
  },
  components: {
    Banner,
  },
  mounted() {
    // 百度地图API功能
    // var map = new BMap.Map("allmap");    // 创建Map实例
    // let point = new BMap.Point(113.547587, 22.1368)
    // map.centerAndZoom(point, 15);  // 初始化地图,设置中心点坐标和地图级别
    // //添加地图类型控件
    // var marker = new BMap.Marker(point);  // 创建标注
    // map.addOverlay(marker);
    // map.addControl(new BMap.MapTypeControl({
    //   mapTypes:[
    //           BMAP_NORMAL_MAP,
    //           BMAP_HYBRID_MAP
    //       ]}));
    // map.setCurrentCity("珠海");          // 设置地图显示的城市 此项是必须设置的
    // map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
    // var opts = {
    //   width : 100,     // 信息窗口宽度
    //   height: 100,     // 信息窗口高度
    //   title : "珠海漫漫科技有限公司" , // 信息窗口标题
    // }
    // var infoWindow = new BMap.InfoWindow("地址：珠海市横琴澳门青年创意谷19栋411室", opts);  // 创建信息窗口对象
    // map.openInfoWindow(infoWindow,point);
    // marker.addEventListener("click", function(){
    //    //开启信息窗口
    // });
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 50px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 16px;
  color: #909399;
  text-align: center;
  line-height: 1.5;
  .sub {
    width: 200px;
    padding-left: 100px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .title {
    color: #000;
    font-size: 24px;
    margin-bottom: 10px;
    align-self: center;
  }
}
.mapWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: auto;
    width: auto;
  }
}
.img_wraper {
  width: 100%;
  margin-top: 20px;
}
.company-adress {
  width: 900px;
  margin-left: 20px;
}
</style>